
window.addEventListener('resize', changeScreen, false)
changeScreen();
export function changeScreen() {
  var phoneWidth = parseInt(window.screen.width);
  var phoneHeight = parseInt(window.screen.height);
  function direction() {
     // ipad、iphone竖屏，Android横屏
      if (window.orientation == 90 || window.orientation == -90) {
          if(phoneWidth < phoneHeight) {
              var a = phoneWidth;
              phoneWidth = phoneHeight;
              phoneHeight = a;
          }
      }
  }
  direction();
  var viewport = document.querySelector("meta[name=viewport]");
  var phoneScale;
  let isPad = navigator.userAgent.toLowerCase().match(/iPad/i);
  if(phoneWidth < phoneHeight) {
    phoneScale = 1
    if(isPad &&  isPad[0] === 'ipad') {
      viewport.setAttribute('content', '"width=device-width, initial-scale='+phoneScale+',minimum-scale='+phoneScale+',maximum-scale='+phoneScale+',user-scalable=no"');
    } else {
      viewport.setAttribute('content', '"target-densitydpi=device-dpi,width=device-width, initial-scale='+phoneScale+',minimum-scale='+phoneScale+',maximum-scale='+phoneScale+',user-scalable=no"');
    }
  } else {
    
    if(isPad && isPad[0] === 'ipad') {
      phoneScale = 1;
      viewport.setAttribute('content', '"width=device-width, initial-scale='+phoneScale+',minimum-scale='+phoneScale+',maximum-scale='+phoneScale+',user-scalable=no"');
      
    } else {
      phoneScale = 0.6;
      viewport.setAttribute('content', '"target-densitydpi=device-dpi,width=device-width, initial-scale='+phoneScale+',minimum-scale='+phoneScale+',maximum-scale='+phoneScale+',user-scalable=no"');
    }
  }
}